import React, { Component, Fragment } from "react";
import ReeValidate from 'ree-validate'
import Header from './Header';
import Footer from './Footer';
import { connect } from "react-redux";
import { sendContactMessage } from "../store/actions/auth";
class ContactUsPage extends Component {
    constructor(props){
        super(props)
        this.validator = new ReeValidate({
          email: 'required|email|max:80',
          name: 'required|max:50',
          comments: 'required',
          phone: 'required|numeric|min:8|max:10'
        })
        this.state = {
          formData: {
            email: '',
            name: '',
            phone: '',
            comments: ''
          },
          formErrors: this.validator.errors
        }
    }

    handleSubmit = e => {
        e.preventDefault()
        const { formData } = this.state
        const { errors } = this.validator
        const { sendContactMessage } = this.props
        this.validator.validateAll(formData)
          .then(success => {
            if (success) {
              sendContactMessage({
                email: formData.email,
                name: formData.name,
                phone: formData.phone,
                comments: formData.comments
              }).then(() => {
                  this.clearFields();
              }).catch(() =>{
                return
              })
            } else {
              this.setState({ formErrors: errors })
            }
          })
    }

    clearFields () {
        this.setState({
            formData: {
                email: '',
                name: '',
                phone: '',
                comments: ''
            }
        })
        this.comments.value = '';
    }

    handleChange = e => {
        const name = e.target.name
        const value = e.target.value
        const { errors } = this.validator
        errors.remove(name)
        this.setState({ formData: { ...this.state.formData, [name]: value } })
        this.validator.validate(name, value)
          .then(() => {
            this.setState({ formErrors: errors })
        })
    }
  
    render() {
        return (
            <Fragment>
            <Header {...this.props}/>
            <div className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed">
            <div className="container">
                <div className="row">
                    <div className="content-box video-popup">
                        <div className="col-md-10 col-md-offset-1">
                            <div className="content">
                                <h1>Contact us</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="contact" className="contact-us-area default-padding">
            <div className="container">
                <div className="row" style={{marginTop:'-100px'}}>
             
                   {
                       /**
                        *  <div className="col-md-8 contact-form">
                        <h2>Send us a message </h2>
                        <form onSubmit={this.handleSubmit} className="contact-form" noValidate>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="form-group">
                                    <input type="text" 
                                        className="form-control" 
                                        id="name" 
                                        placeholder="Name" 
                                        name="name"
                                        onChange={this.handleChange}
                                        required
                                        maxLength={50}
                                        value={formData.name}/>
                                        { formErrors.has('name') &&
                                            <span className="error text-danger">{ formErrors.first('name') }</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                    <input type="email" 
                                        className="form-control" 
                                        id="email" 
                                        placeholder="Enter email" 
                                        name="email"
                                        onChange={this.handleChange}
                                        required
                                        maxLength={80}
                                        value={formData.email}/>
                                        { formErrors.has('email') &&
                                            <span className="error text-danger">{ formErrors.first('email') }</span>
                                        }
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                    <input type="text" 
                                        className="form-control" 
                                        id="phone" 
                                        placeholder="Phone" 
                                        name="phone"
                                        onChange={this.handleChange}
                                        required
                                        maxLength={10}
                                        value={formData.phone}/>
                                        { formErrors.has('phone') &&
                                            <span className="error text-danger">{ formErrors.first('phone') }</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="form-group comments">
                                    <textarea 
                                        className="form-control" 
                                        ref={(ref) => this.comments = ref}
                                        id="comments" 
                                        placeholder="Tell us about project *" 
                                        name="comments"
                                        onChange={this.handleChange}
                                        required
                                        >{formData.comments}</textarea>
                                        { formErrors.has('comments') &&
                                            <span className="error text-danger">{ formErrors.first('comments') }</span>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <button type="submit" name="submit" id="submit">
                                        Send Message <i className="fa fa-paper-plane"></i>
                                    </button>
                                </div>
                            </div>
                            <div className="col-md-12 alert-notification">
                                <div id="message" className="alert-msg"></div>
                            </div>
                        </form>
                    </div>
                        */
                   }
                    <div className="col-md-4 address">
                        <div className="address-items">
                            <ul className="info">
                                <li>
                                    <h4>Office Location</h4>
                                    <div className="icon"><i className="fas fa-map-marked-alt"></i></div> 
                                    <span>6304 East Castledale ,<br/> Central, LA 70730<br/></span>
                                </li>
                                        {/*
                                <li>
                                    <h4>Phone</h4>
                                    <div className="icon"><i className="fas fa-phone"></i></div> 
                                    <span>+44-20-7328-4499 <br/>+99-34-8878-9989</span>
                                </li>
                                        */}
                                <li>
                                    <h4>Email</h4>
                                    <div className="icon"><i className="fas fa-envelope-open"></i> </div>
                                    <span>support@Fitbanx.com

                                    <br/></span>
                                </li>
                            </ul>
                            {/*
                            <h4>Social Address</h4>
                            <ul className="social">
                                <li className="facebook">
                                    <a><i className="fab fa-facebook-f"></i></a>
                                </li>
                                <li className="twitter">
                                    <a><i className="fab fa-twitter"></i></a>
                                </li>
                                <li className="pinterest">
                                    <a><i className="fab fa-pinterest"></i></a>
                                </li>
                                <li className="instagram">
                                    <a><i className="fab fa-instagram"></i></a>
                                </li>
                            </ul>
                             */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
       {/**
        *  <div className="maps-area">
            <div className="container-full">
                <div className="row">
                    <div className="google-maps">
                        <iframe title="location" src="https://www.google.com/maps/embed?pb=!1m10!1m8!1m3!1d14767.262289338461!2d70.79414485000001!3d22.284975!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1424308883981"></iframe>
                    </div>
                </div>
            </div>
        </div>
        */}
        <Footer {...this.props}/>
        </Fragment>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {}
  }
  const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      sendContactMessage: (data) => {
        return dispatch(sendContactMessage(data));
      }
    }
  }

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsPage);



// WEBPACK FOOTER //
// ./src/components/ContactUsPage.js